import { fromJS } from 'immutable';
import * as ActionTypes from '../lib/constants/ActionTypes';
import PostApprovalPlaidAttemptRecord from '../records/post_approval_plaid_attempt';

const newState = () =>
  fromJS({
    application_id: null,
    attempt: new PostApprovalPlaidAttemptRecord(),
    has_attempt: false,
    pre_attempt_can_continue: null,
    pre_attempt_next_route_path: null,
    request_generation: 0,
    loading: false,
    idempotency_key: null,
    last_error: null,
  });

export const postApprovalPlaidState = newState();

const safeError = (error) =>
  fromJS({
    http_status: error.http_status,
    outcome: error.outcome,
    reason_code: error.reason_code,
    can_continue: error.can_continue,
    next_route_path: error.next_route_path,
    network: error.network,
  });

const resetForApplication = (state, applicationId) =>
  newState().merge({
    application_id: applicationId,
    request_generation: state.get('request_generation') + 1,
    loading: true,
  });

export default function postApprovalPlaid(
  state = postApprovalPlaidState,
  action
) {
  switch (action.type) {
    case ActionTypes.POST_APPROVAL_PLAID_REQUEST_STARTED:
      if (
        state.get('application_id') &&
        state.get('application_id') !== action.payload
      ) {
        return resetForApplication(state, action.payload);
      }

      return state.merge({
        application_id: action.payload,
        request_generation: state.get('request_generation') + 1,
        loading: true,
        last_error: null,
      });

    case ActionTypes.POST_APPROVAL_PLAID_STATUS_RECEIVED:
      if (action.generation !== state.get('request_generation')) return state;

      if (action.payload.kind === 'attempt') {
        if (
          !(action.payload.attempt instanceof PostApprovalPlaidAttemptRecord)
        ) {
          return state;
        }

        return state.merge({
          attempt: action.payload.attempt,
          has_attempt: true,
          pre_attempt_can_continue: null,
          pre_attempt_next_route_path: null,
          loading: false,
          last_error: null,
        });
      }

      return state.merge({
        attempt: new PostApprovalPlaidAttemptRecord(),
        has_attempt: false,
        pre_attempt_can_continue: action.payload.can_continue,
        pre_attempt_next_route_path: action.payload.next_route_path,
        loading: false,
        last_error: null,
      });

    case ActionTypes.POST_APPROVAL_PLAID_REQUEST_FAILED:
      if (action.generation !== state.get('request_generation')) return state;

      return state.merge({
        loading: false,
        last_error: safeError(action.payload),
      });

    case ActionTypes.POST_APPROVAL_PLAID_IDEMPOTENCY_KEY_SET:
      if (
        action.expectedKey &&
        state.get('idempotency_key') !== action.expectedKey
      ) {
        return state;
      }
      return state.set('idempotency_key', action.payload);

    case ActionTypes.POST_APPROVAL_PLAID_RESET:
      return newState().set(
        'request_generation',
        state.get('request_generation') + 1
      );

    default:
      return state;
  }
}
